import { type FlowEvaluationBlockConfig, FlowEvaluationType } from 'flow-schema';

export function getDefaultEvaluationConfig(): FlowEvaluationBlockConfig {
  return {
    output: '',
    reference: '',
    evaluationType: FlowEvaluationType.Accuracy,
  };
}
